module.exports = __webpack_public_path__ + "static/media/tablet.33a92a0e.png";